import { Phone } from "lucide-react";
import { InfoCard, InfoCardValue, InfoCardMuted } from "@/components/ui/InfoCard";

interface PatientDetailsPhoneCardProps {
  phone: string;
}

export function PatientDetailsPhoneCard({
  phone,
}: PatientDetailsPhoneCardProps) {
  return (
    <InfoCard>
      <div className="flex items-center px-5 py-3.5">
        <div className="mr-3 flex shrink-0">
          <Phone
            className="text-action-disabled-content size-3.5"
            strokeWidth={1.8}
          />
        </div>
        <InfoCardMuted className="w-[84px] shrink-0">Phone</InfoCardMuted>
        <InfoCardValue className="flex-1">{phone}</InfoCardValue>
      </div>
    </InfoCard>
  );
}
